import React, { Component } from 'react';

import { pick } from 'lodash';

import '../css/round-button.css';

class RoundButton extends Component {
  render() {
    const className = ['round-button btn', this.props.className || ''].join(' ');
    let props = {
      ...pick(this.props, [
        'disabled',
        'onClick',
        'target',
      ]),
      className,
    };
    const { href, type } = this.props;

    if (href) {
      return (
        <a {...props} href={href}>
          {this.props.children}
        </a>
      );
    }

    return (
      <button {...props} type={type}>
        {this.props.children}
      </button>
    );
  }
}

RoundButton.defaultProps = {
  type: 'button',
  disabled: false,
};

export default RoundButton;



// WEBPACK FOOTER //
// ./src/mobile/components/round-button.js